module.exports = __webpack_public_path__ + "assets/8e714da9798b2eaf694cc6a8eb64b8a3.png";